import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let inited = false;

export const initAnalytics = () => {
  if (inited || !KEY) return;
  posthog.init(KEY, {
    api_host: HOST,
    capture_pageview: false, // we'll do route-based captures manually
    persistence: "localStorage",
    autocapture: true,
    person_profiles: "identified_only",
  });
  inited = true;
};

export const identify = (user) => {
  if (!KEY || !user) return;
  posthog.identify(user.id, {
    email: user.email,
    handle: user.handle,
    plan: user.plan,
    display_name: user.display_name,
  });
};

export const resetAnalytics = () => {
  if (!KEY) return;
  try {
    posthog.reset();
  } catch {}
};

export const track = (event, props = {}) => {
  if (!KEY) return;
  try {
    posthog.capture(event, props);
  } catch {}
};

export const pageview = (path) => {
  if (!KEY) return;
  try {
    posthog.capture("$pageview", { $current_url: window.location.href, path });
  } catch {}
};
